import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
import { func, bool, string } from 'prop-types';
import { get } from 'lodash';

import * as user from 'modules/user';
import {
  TextField,
  requireFields,
  SelectField,
  Checkbox
} from 'helpers/redux/form';
// import developerTypeData from './developer_type.json';
import earlyAdopterProgramData from './early_adopter_program_data.json';
import styles from '../styles/form';
import { Row, Col } from 'shared-components/grid';
import ProgressButton from 'shared-components/ProgressButton';
import MenuItem from '@material-ui/core/MenuItem';
import CountrySelectField from 'shared-components/CountrySelectField';
import { formValueSelector } from 'redux-form';

const requiredFields = [
  // 'firstName',
  // 'lastName',
  // /* Removing title and developerType until added to API */
  // // 'title',
  // // 'developerType',
  // 'phoneNumber',
  // 'companyName',
  // 'companyUrl',
  // 'companyDescription',
  // 'companyAddress',
  // 'companyCity',
  // 'companyState',
  // 'companyZipCode',
  // 'companyCountry',
];

// submitting: user.isLoggingIn(state),
// submitFailed: user.loginFailed(state),
// submitFailureMessage:
@connect(state => {
  const _user = user.selectUser(state);
  const firstName = get(_user, 'kvp.firstName', '');
  const lastName = get(_user, 'kvp.lastName', '');
  const selector = formValueSelector('onboarding-profile-entry');
  const isReferred = selector(state, 'isReferred');
  const earlyAdopterProgram = selector(state, 'earlyAdopterProgram');
  // const title = get(_user, 'kvp.title');
  // const developerType = get(_user, 'kvp.developerType');

  return {
    initialValues: {
      companyUrl: 'https://',
      firstName,
      lastName,
      isReferred: false,
      referredBy: '',
      useCase: '',
      earlyAdopterProgram: '',
      // title,
      // developerType,
      ...user.selectUserOrganizationKvp(state)
    },
    isReferred: isReferred || false,
    earlyAdopterProgram
  };
})
@reduxForm({
  form: 'onboarding-profile-entry',
  validate: requireFields(requiredFields)
})
export default class ProfileEntryForm extends React.Component {
  static propTypes = {
    submitting: bool,
    submitFailed: bool,
    valid: bool,
    handleSubmit: func.isRequired,
    submitFailureMessage: string,
    isReferred: bool,
    earlyAdopterProgram: string
  };
  static defaultProps = {};

  // TODO: remove below handleSkip func after CXDX-143 is fine
  handleSkip = () => {
    window.location.replace('/overview');
  };

  render() {
    const formFieldClasses = cx(styles['form-field']);
    const formCheckBoxClasses = cx(
      styles['form-checkbox'],
      styles['form-field']
    );
    const { isReferred, earlyAdopterProgram, handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit} className={styles.form}>
        {/* <Row>
          <Col lg={12}>
            <Field
              label="Title"
              name="title"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>
        </Row> */}

        <Row>
          <Col lg={6}>
            <Field
              label="First Name"
              name="firstName"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>

          <Col lg={6}>
            <Field
              label="Last Name"
              name="lastName"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Field
              label="Phone Number"
              name="phoneNumber"
              type="tel"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>

          {/* <Col lg={6}>
            <Field
              floatingLabelText="Developer Type"
              name="developerType"
              className={formFieldClasses}
              component={SelectField}
            >
              {developerTypeData.map(developer_type =>
                <MenuItem key={developer_type.key} value={developer_type.key}>
                  {developer_type.value}
                </MenuItem>
              )}
            </Field>
          </Col> */}
        </Row>

        <Row>
          <Col lg={6}>
            <Field
              label="Company Name"
              name="companyName"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>

          <Col lg={6}>
            <Field
              label="Company URL"
              name="companyUrl"
              type="url"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Field
              label="Company Description"
              name="companyDescription"
              type="text"
              multiLine
              rows={3}
              rowsMax={5}
              className={formFieldClasses}
              component={TextField}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={6}>
            <Field
              label="Company Street Address"
              name="companyAddress"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>

          <Col lg={6}>
            <Field
              label="Suite or Apt #"
              name="companySuiteApt"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={6}>
            <Field
              label="City/Location"
              name="companyCity"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>

          <Col lg={3}>
            <Field
              label="State/Province"
              name="companyState"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>

          <Col lg={3}>
            <Field
              label="Zip/Postal Code"
              name="companyZipCode"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={6}>
            <Field
              label="Country"
              name="companyCountry"
              className={formFieldClasses}
              component={CountrySelectField}
            />
          </Col>
        </Row>

        <Row className={styles['early-adopters-program-row']}>
          <Col lg={12}>
            <div className={styles['early-adopters-program-header']}>
              Participate In Veritone&apos;s Early Adopter Program
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <Field
              label="Early Adopter Program"
              name="earlyAdopterProgram"
              className={formFieldClasses}
              component={SelectField}
              children={earlyAdopterProgramData.map(program =>
                <MenuItem key={program.label} value={program.value}>
                  {program.label}
                </MenuItem>
              )}
            />
          </Col>
          <Col lg={1}>
            <Field
              disabled={!earlyAdopterProgram || earlyAdopterProgram === 'None'}
              name="isReferred"
              className={formCheckBoxClasses}
              component={Checkbox}
              color="primary"
            />
          </Col>
          <Col lg={5}>
            <Field
              label="Referred By"
              name="referredBy"
              className={formFieldClasses}
              component={TextField}
              disabled={!isReferred}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Field
              disabled={!earlyAdopterProgram || earlyAdopterProgram === 'None'}
              label="What Problem Will Automate Studio Solve For You?"
              name="useCase"
              className={formFieldClasses}
              component={TextField}
            />
          </Col>
        </Row>

        {/* <Row>
          <Col lg={6}>
            <Field
              label="Enrollment Code"
              name="enrollmentCode"
              type="text"
              className={formFieldClasses}
              component={TextField}
            />
            <p className={styles['enrollment-instructions']}>
              If you have an enrollment code, enter it here.
            </p>
          </Col>
        </Row> */}

        <Row>
          <Col lg={12}>
            <div className={styles['submit-area']}>
              {this.props.submitFailed &&
                <p>
                  {this.props.submitFailureMessage}
                </p>}
              <ProgressButton
                type="submit"
                label="Complete"
                loading={this.props.submitting}
                disabled={this.props.submitting || !this.props.valid}
                primary
                variant="contained"
              />
            </div>
          </Col>
        </Row>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/onboarding/pages/profile-entry/components/ProfileEntryForm.js